import {
  Component,
  EventEmitter,
  Inject,
  LOCALE_ID,
  OnInit,
  Input,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppConstants } from "src/app/constants/constants";
import { UserDisplayHeader } from "src/app/_models/UserDisplayHeader";
import { ClearState } from "src/app/_store/_store.actions";
import { selectHasDirtyForm } from "src/app/_store/navigation/navigation.selectors";
import { takeUntil } from "rxjs/operators";
import { BaseComponent } from "../../base/base-component.component";
import { AllowUnload } from "src/app/_store/navigation/navigation.actions";
import { selectUserInformationHeaders } from "src/app/_store/user-profile/user-profile.selectors";
import {
  InformationHeader,
  initialInformationHeader,
} from "src/app/_models/InformationHeader";
import { APP_CONFIG } from "src/app/lib/angular/injection-tokens";
import { IAppConfig } from "src/app/lib/config/app-config";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent extends BaseComponent implements OnInit {
  @Output() public sidenavToggle = new EventEmitter();
  @Output() sidenavClose = new EventEmitter();
  @Output() loggingout = new EventEmitter();
  @Output() changingPassword = new EventEmitter();
  @Input() loginDisplay: boolean;
  @Input() userDetail: UserDisplayHeader;
  @Input() isAdmin: boolean;
  scormContentNotExist: boolean = true;
  siteLanguageCode: string = this.localeId;
  siteLanguage: string = "English";
  siteLocale: string;
  badgeHidden: boolean;
  userFullname: string;
  userEmail: string;
  menuOpen: boolean;
  hasDirtyForm: boolean;
  informationHeader: InformationHeader = initialInformationHeader;
  isDevEnvironment: boolean;

  constructor(
    @Inject(LOCALE_ID) protected localeId: string,
    private router: Router,
    private store: Store,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {
    super();
  }

  ngOnInit(): void {
    this.isDevEnvironment = this.config.isDevEnvironment;
    this.getRouterResult();

    this.store
      .select(selectHasDirtyForm)
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: boolean) => {
        this.hasDirtyForm = result;
      });

    this.selectorInformationHeader();
  }

  selectorInformationHeader(): void {
    this.store
      .select(selectUserInformationHeaders)
      .pipe(takeUntil(this.destroy$))
      .subscribe((info: InformationHeader) => {
        if (Object.keys(info).filter((r) => info[r] == true).length > 0) {
          this.informationHeader = info;
        }
      });
  }

  public changeLanguage = () => {
    if (this.continueEmit()) {
      this.store.dispatch(AllowUnload({ value: true }));
      if (this.siteLanguageCode == AppConstants.WELSH_LANG_CODE) {
        window.location.href = `/${AppConstants.DEFAULT_LANG_CODE}${this.router.url}`;
      } else if (this.siteLanguageCode == AppConstants.DEFAULT_LANG_CODE) {
        window.location.href = `/${AppConstants.WELSH_LANG_CODE}${this.router.url}`;
      }
    }
  };

  public onToggleSidenav = () => {
    this.sidenavToggle.emit();
  };

  public onSidenavClose = () => {
    this.sidenavClose.emit();
  };

  public logout = () => {
    if (this.continueEmit()) {
      this.store.dispatch(AllowUnload({ value: true }));
      this.loggingout.emit();
    }
  };

  public changePassword = () => {
    if (this.continueEmit()) {
      this.store.dispatch(AllowUnload({ value: true }));
      this.store.dispatch(ClearState());
      this.changingPassword.emit();
    }
  };

  public getRouterResult() {
    this.router.events.subscribe(() => {
      const result: string = this.router.url;
      if (result.includes(AppConstants.CONTENT_PLAYER_PAGE)) {
        this.scormContentNotExist = false;
      } else {
        this.scormContentNotExist = true;
      }
    });
  }

  public continueEmit(): boolean {
    let continueProcess: boolean = true;
    return this.hasDirtyForm
      ? confirm(AppConstants.DIRTY_FORM)
      : continueProcess;
  }
}
